import { render, staticRenderFns } from "./SidebarNavigationSubItem.vue?vue&type=template&id=c15ca27a&scoped=true&"
import script from "./SidebarNavigationSubItem.vue?vue&type=script&lang=js&"
export * from "./SidebarNavigationSubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15ca27a",
  null
  
)

export default component.exports